export function getUnhandledRejectionEventHandler(logError: (error: Error) => void) {
  return (evt: PromiseRejectionEvent) => {
    let err = evt?.reason
    if (!evt?.reason) {
      let extraInfo = ''
      if (evt && typeof evt === 'object') {
        extraInfo += evt.constructor?.name ? `constructor name = ${evt.constructor?.name}` : ''
        extraInfo += evt.type ? `, type = ${evt.type}` : ''
      }
      err = new Error(
        `The error was caused due to an "unhandledrejection" event, cause: ${JSON.stringify(evt)}${
          extraInfo ? `, extraInfo: ${extraInfo}` : ''
        }`,
      )
    } else if (evt.reason instanceof Error) {
      err = evt.reason
    } else if (evt.reason instanceof Event) {
      err = new Error(
        `Promise rejected with Event of type "${evt.reason.type}", constructor name = ${evt.reason.constructor
          ?.name}, originalEvent: ${JSON.stringify(evt.reason)}`,
      )
      err.originalEvent = evt.reason
    } else {
      err = new Error(`Promise was rejected with a non-Error value: ${JSON.stringify(evt.reason)}`)
    }
    logError(err)
    evt.preventDefault()
  }
}
